export const PASSENGER_TYPE = {
    ADULT: 'ADT',
    CHILD: 'CHD',
    INFANT: 'INF',
};
/** Each adult may travel with at most this many children and infants combined (NRS rule). */
export const MAX_DEPENDANTS_PER_ADULT = 4;
function isoParts(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    if (!match)
        return null;
    return [Number(match[1]), Number(match[2]), Number(match[3])];
}
/** Whole years between two ISO dates (YYYY-MM-DD), or null when either is invalid. */
export function ageOn(birthDate, onDate) {
    const birth = isoParts(birthDate);
    const on = isoParts(onDate);
    if (!birth || !on)
        return null;
    let age = on[0] - birth[0];
    if (on[1] < birth[1] || (on[1] === birth[1] && on[2] < birth[2]))
        age -= 1;
    return age;
}
/**
 * IATA age bands evaluated on the travel date: infant under 2, child 2–11, adult 12+.
 * Returns null for a birth date after the travel date or an unparsable date.
 */
export function passengerTypeOn(birthDate, travelDate) {
    const age = ageOn(birthDate, travelDate);
    if (age === null || age < 0)
        return null;
    if (age < 2)
        return PASSENGER_TYPE.INFANT;
    if (age < 12)
        return PASSENGER_TYPE.CHILD;
    return PASSENGER_TYPE.ADULT;
}
export function validatePassengerMix(types) {
    const adults = types.filter((t) => t === PASSENGER_TYPE.ADULT).length;
    const infants = types.filter((t) => t === PASSENGER_TYPE.INFANT).length;
    const dependants = types.length - adults;
    if (adults === 0)
        return 'NO_ADULT';
    if (infants > adults)
        return 'TOO_MANY_INFANTS';
    if (dependants > adults * MAX_DEPENDANTS_PER_ADULT)
        return 'TOO_MANY_DEPENDANTS';
    return null;
}
/** Infants travel on an adult's lap, so they do not need a seat. */
export function seatsRequired(types) {
    return types.filter((t) => t !== PASSENGER_TYPE.INFANT).length;
}
//# sourceMappingURL=passengers.js.map